import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { UploadError } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import addCartLineCollectionFromProducts from "@insite/client-framework/Store/Pages/OrderUpload/Handlers/AddCartLineCollectionFromProducts";
import translate from "@insite/client-framework/Translate";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderUpload, { OrderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import OrderUploadErrorsModal, {
    OrderUploadErrorsModalStyles,
} from "@insite/content-library/Components/OrderUploadErrorsModal";
import ItemTrackingFile from "@tKgpco/Overrides/Components/ItemTrackingFile";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    addCartLineCollectionFromProducts,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface ItemTrackingFileUploadStyles {
    orderUploadStyles?: OrderUploadStyles;
    orderUploadErrorsModalStyles?: OrderUploadErrorsModalStyles;
}

export const ItemTrackingFileUploadStyles: ItemTrackingFileUploadStyles = {};

const styles = ItemTrackingFileUploadStyles;

const ItemTrackingFileUpload: FC<Props> = ({ addCartLineCollectionFromProducts, id }) => {
    const uploadProductsHandler = (products: ProductDto[], onSuccess?: () => void) => {
        addCartLineCollectionFromProducts({ products, onSuccess });
    };

    return (
        <>
            <ItemTrackingFile
                id={id}
                descriptionText={siteMessage("ItemTrackingUpload_Instructions_UploadExcel")}
                checkInventory={true}
                templateUrl="/userfiles/ItemTrackingImport.xlsx"
                onUploadProducts={uploadProductsHandler}
                extendedStyles={styles.orderUploadStyles}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(ItemTrackingFileUpload),
    definition: {
        group: "Basic",
        displayName: "Item Tracking File Upload",
    },
};

export default widgetModule;
